import { updateAutoApprovalStatus } from "@/api/admin";
import { CustomSelect } from "@/components";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import useAuth from "@/hooks/useAuth";
import { showSuccessToast } from "@/lib/toast";
import { useMutation } from "@tanstack/react-query";
import { Formik } from "formik";
import * as Yup from "yup"

const validationSchema = Yup.object().shape({
   approver: Yup.string().oneOf(["staff", "admin"]).required("This field is required")
})

const LessonSettings = () => {
   const { setSchool, school } = useAuth()

   const initialValues = {
      schoolID: school?.id,
      approver: school?.options?.["course-approver"]
   };
   const { mutate, isLoading } = useMutation(updateAutoApprovalStatus, {
      onSuccess: ({ data }) => {
         showSuccessToast("Lesson approver has been changed successfully");
         setSchool(data)
      }
   })

   return (
      <Card className="mt-13 rounded-[20px] border-transparent px-4 py-5 md:px-5 md:py-6 lg:px-10 lg:py-11">
         <Formik validationSchema={validationSchema} initialValues={initialValues} onSubmit={(data) => mutate(data)}>
            {({ values, setFieldValue, handleSubmit }) => {
               return (
                  <form onSubmit={handleSubmit}>
                     <div className="space-y-8">
                        <CustomSelect
                           options={[
                              { label: "Teacher", value: "staff" },
                              { label: "Admin", value: "admin" },
                           ]}
                           name="approver"
                           value={values.approver}
                           onChange={(val) => setFieldValue("approver", val)}
                           label="Select lesson approver"
                           placeholder="Select lesson approver"
                        />

                        <div className="flex h-full py-0.5 md:items-end">
                           <Button disabled={isLoading} className="rounded-lg ">
                              Update
                           </Button>
                        </div>
                     </div>
                  </form>
               );
            }}
         </Formik>
      </Card>
   );
};

export default LessonSettings;
